import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import "../common/index.scss";
import { connect, useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";

// import custom Components
import Service from "./common/service";
import BrandBlock from "./common/brand-block";
import NewProduct from "../common/new-product";
import Breadcrumb from "../common/breadcrumb";
import DetailsWithPrice from "./common/product/details-price";
import DetailsTopTabs from "./common/details-top-tabs";
import {
  cart_actions,
  wishlist_actions,
  adcard_actions,
  product_actions,
} from "../../redux-store";
import ImageZoom from "./common/product/image-zoom";
import SmallImages from "./common/product/small-image";
import RelatedProduct from "../common/related-product";

const LeftSideBar = (props) => {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [state, setState] = useState(false);
  const { items: cart } = useSelector((state) => state.cart);
  const { items: wishlist } = useSelector((state) => state.wishlist_);
  const { user } = useSelector((state) => state?.auth);
  const { item } = props;

  useEffect(() => {
    if (item) {
      if (cart && cart.length === 0) {
        setState(false);
      } else if (
        cart &&
        cart.length > 0 &&
        cart[0].product.merchant_user === item.merchant_user._id
      ) {
        setState(false);
      } else if (
        cart &&
        cart.length > 0 &&
        cart[0].product.merchant_user !== item.merchant_user._id
      ) {
        setState(true);
      }
    }
  }, [cart, item]);

  const { symbol, add_to_cart, add_to_wishlist, create_adcard } = props;
  var products = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    fade: true,
  };

  const filterClick = () => {
    document.getElementById("filter").style.left = "-15px";
  };
  const backClick = () => {
    document.getElementById("filter").style.left = "-365px";
  };

  const getProductDetail = () => {
    dispatch(
      product_actions.fetch_products({
        published: true,
        _id: id,
      })
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [id]);

  return (
    <div>
      {/*SEO Support*/}
      <Helmet>
        <title>
          eksplode | {item ? item.product_category.category_name : "Category"} |{" "}
          {item ? item.product_name : "Product"}
        </title>
      </Helmet>
      {/*SEO Support End */}

      <Breadcrumb
        parent={"Product"}
        title={item ? item.product_name : "Product"}
      />

      {/*Section Start*/}
      {item ? (
        <section className="section-b-space">
          <div className="collection-wrapper">
            <div className="container">
              <div className="row">
                <div className="col-sm-3 collection-filter" id="filter">
                  <div className="collection-mobile-back pl-5">
                    <span onClick={() => backClick()} className="filter-back">
                      <i className="fa fa-angle-left" aria-hidden="true" /> back
                    </span>
                  </div>
                </div>
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <div className="">
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="filter-main-btn mb-2">
                          <span
                            onClick={() => filterClick()}
                            className="filter-btn"
                          >
                            <i className="fa fa-filter" aria-hidden="true" />{" "}
                            filter
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 product-thumbnail">
                        <Slider
                          {...products}
                          asNavFor={nav2}
                          ref={setNav1}
                          className="product-slick"
                        >
                          {item.product_images.map(({ image }, index) => (
                            <div key={index}>
                              <ImageZoom image={image} />
                            </div>
                          ))}
                        </Slider>
                        <SmallImages
                          item={item}
                          settings={{
                            slidesToShow: 3,
                            swipeToSlide: true,
                            arrows: false,
                            dots: false,
                            focusOnSelect: true,
                          }}
                          navOne={nav1}
                        />
                      </div>
                      <div className="col-lg-6">
                        <DetailsWithPrice
                          symbol={symbol}
                          item={item}
                          state={state}
                          navOne={nav1}
                          addToCartClicked={add_to_cart}
                          BuynowClicked={() => {}}
                          addToWishlistClicked={add_to_wishlist}
                          create_adcard={create_adcard}
                          cart={cart}
                          wishlist={wishlist}
                        />
                        <DetailsTopTabs item={item} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {user?.user?.role !== "merchant" && (
                <RelatedProduct product={item} />
              )}
            </div>
          </div>
        </section>
      ) : (
        ""
      )}
      {/*Section End*/}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  let productId = ownProps.match.params.id;
  return {
    item: state.products.data.find((el) => el._id == productId),
    symbol: state.data.symbol,
    adcards: state.adcard,
    user: state.auth.user,
  };
};
const mapDispatchToProps = (dispatch) => ({
  add_to_cart: (unit) => dispatch(cart_actions.add_to_cart(unit)),
  add_to_wishlist: (unit) => dispatch(wishlist_actions.add_to_wishlist(unit)),
  create_adcard: (unit) => dispatch(adcard_actions.create_adcard(unit)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeftSideBar)
);
